import { tss } from 'tss-react/mui';

export const useStyles = tss.withName('LayoutFooter').create(({ theme }) => ({
  root: {
    backgroundColor: theme.palette.background.defaultDark
  },
  appbar: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    gridTemplateRows: '1fr',
    gridTemplateAreas: `"logo menus" "copyright copyright"`,
    rowGap: theme.gutter.lg,
    border: 'none',

    [theme.containerQueries.down('desktop')]: {
      rowGap: 0,
      gridTemplateAreas: `"logo menus" "empty copyright"`
    },

    [theme.containerQueries.down('tablet')]: {
      gridTemplateAreas: `"logo" "menus" "copyright"`,
      gridTemplateColumns: '1fr'
    }
  },
  logo: {
    gridArea: 'logo',
    '& img': {
      [theme.containerQueries.down('tablet')]: {
        height: theme.typography.pxToRem(14)
      }
    }
  },
  menus: {
    gridArea: 'menus',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: theme.spacing(0, 0, 0, theme.gutter.md),

    [theme.containerQueries.down('desktop')]: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      gap: theme.gutter.lg,
      gridTemplateRows: 'minmax(100px, 1fr) auto',
      padding: `0 0 ${theme.gutter.xl} ${theme.gutter.sm}`
    },

    [theme.containerQueries.down('tablet')]: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      gridTemplateRows: '1fr 1fr',
      gap: 0,
      padding: 0,
      placeItems: 'center'
    }
  },
  menu: {
    flex: 1,
    padding: 0,

    [theme.containerQueries.down('tablet')]: {
      '&:nth-of-type(3n)': {
        justifySelf: 'flex-end'
      },
      '&:nth-of-type(3n + 1)': {
        justifySelf: 'flex-start'
      }
    }
  },
  copyright: {
    gridArea: 'copyright',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.gutter.md,

    [theme.containerQueries.down('desktop')]: {
      justifyContent: 'flex-start'
    },

    [theme.containerQueries.down('tablet')]: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridTemplateAreas: `"terms policy" "link link"`,
      gap: theme.gutter.md,
      padding: theme.gutter.md + ' 0',
      placeItems: 'center'
    }
  },
  copyrightText: {
    gridArea: 'link',

    [theme.containerQueries.down('desktop')]: {
      marginLeft: theme.gutter.sm,
      paddingLeft: theme.gutter.sm
    }
  },
  copyrightPolicy: {
    gridArea: 'policy',
    justifySelf: 'flex-end'
  },
  copyrightTerms: {
    gridArea: 'terms',
    justifySelf: 'flex-start'
  },
  mainMenuItem: {
    whiteSpace: 'nowrap',

    [theme.containerQueries.down('tablet')]: {
      padding: 0
    }
  }
}));
